import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { fetchLoginOption } from 'store/login';

import SplitPageContainer from 'components/SplitPageContainer';
import SplitPageRight from 'components/SplitPageRight';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import samlInit from 'helpers/samlInit';

function SsoEnabled() {
  const classes = useStyles();
  const loginState = useSelector(state => state.login);
  const additionalParams = useSelector(state => state.app.params);

  const { email, loginDomains } = loginState;
  const dispatch = useDispatch();
  const routeMatch = useRouteMatch();
  const subdomain = routeMatch.params.subdomain;

  useEffect(
    () => {
      dispatch(fetchLoginOption(email));
    },
    [dispatch, email],
  );

  if (loginDomains.length === 0) {
    return null;
  }

  const handleSubmit = () => {
    const loginOptionResponse = loginDomains.find(item => item.subdomain === subdomain);

    samlInit(loginOptionResponse, additionalParams);
  };

  return (
    <SplitPageContainer>
      <SplitPageRight>
        <Typography className={classes.headline}>Your organization has SSO enabled</Typography>
        <Typography className={classes.textBody} variant="body1">
          No need to worry about creating another password! Your organization has enabled Single
          Sign-On (SSO), which means you can simply sign in using your existing SSO credentials.
          This makes the sign-in process fast and secure, giving you one less password to remember.
        </Typography>
        <Button className="ssoLogin" color="secondary" variant="contained" onClick={handleSubmit}>
          Login with single sign-on (SSO)
        </Button>
      </SplitPageRight>
    </SplitPageContainer>
  );
}

const useStyles = makeStyles(theme => {
  return {
    headline: {
      fontSize: 34,
      marginBottom: theme.spacing(),
      lineHeight: '42.74px',
      letterSpacing: '0.25px',
      width: 538,
      height: 43,
    },
    textBody: {
      fontSize: 16,
      lineHeight: '28px',
      letterSpacing: '0.5px',
      marginBottom: theme.spacing(6),
      width: 711,
      height: 76,
    },
  };
});

export default SsoEnabled;
